import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface HeaderStore {
  label: string;
  setLabel: (label?: string) => void;
}

const useHeaderStore = create<HeaderStore>()(
  devtools((set) => ({
    label: '',
    setLabel: (label) => set({ label }),
  })),
);

export const useHeaderLabel = () => useHeaderStore((state) => state.label);
export const useHeaderSetLabel = () => useHeaderStore((state) => state.setLabel);
